export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/creative_writing.b2537b3.svg";